import axios from "../config/axiosInstance";

export const userService = {
  register: async (userDTO) => {
    return await axios.post(`/users/register`, userDTO);
  },

  logout: async () => {
    return await axios.post(`/users/logout`);
  },

  getInfoUser: async (userId) => {
    return await axios.get(`/users/get-info-user/${userId}`);
  },

  updateInfoUser: async (userId, newInfoUser) => {
    return await axios.put(`/users/update-user/${userId}`, newInfoUser);
  },

  changePassword: async (userId, changePasswordDTO) => {
    return await axios.post(
      `/users/change-password/${userId}`,
      changePasswordDTO,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  },
  getUsersByRole: async (roleName) => {
    return await axios.get(`/users/get-user-by-role?roleName=${roleName}`);
  },
};
